import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Analytics from "../../firebase_services/analytics";
export default () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.app.userData.userData);

  const handleViewMore = async (page) => {
    if (page) {
      if (user?.user?.id) {
        await Analytics.trackListView(page, user?.role);
      }
      navigate(page);
    }
  };
  return { handleViewMore };
};
